<template>
  <DialogBase
    title="Thêm mới phòng ban"
    :visible.sync="dialogVisible"
    size="sm"
    panel-icon="el-icon-office-building"
    panel-title="Thông tin phòng ban"
    panel-subtitle="Tạo phòng ban mới"
    :confirm-loading="loadingButton"
    :confirm-disabled="!showSaveChange"
    confirm-text="Lưu"
    confirm-type="primary"
    cancel-text="Hủy"
    cancel-type=""
    cancel-icon=""
    confirm-icon=""
    @before-close="handleClose"
    @cancel="handleClose"
    @confirm="handleSave"
  >
    <el-form
      ref="dataForm"
      :model="dataForm"
      :rules="formRules"
      label-position="top"
    >
      <el-form-item label="Tên phòng ban" prop="departmentName">
        <el-input
          v-model="dataForm.departmentName"
          placeholder="Nhập tên phòng ban"
        />
        <span v-if="customErrorMessages.newNameKt" class="sk-note sk-note--danger sk-u-mt-12">
          <i class="el-icon-warning-outline" />
          <span>{{ customErrorMessages.newNameKt }}</span>
        </span>
      </el-form-item>
      <el-form-item label="Mô tả" prop="departmentDescription" class="sk-u-mt-12">
        <el-input
          v-model="dataForm.departmentDescription"
          type="textarea"
          :rows="1"
          autosize
          placeholder="Nhập mô tả"
        />
      </el-form-item>
    </el-form>
  </DialogBase>
</template>

<script>
import DialogBase from "@/components/DialogBase.vue";
import DepartmentDataService from "@/services/EmployeeService/DepartmentDataService";
import { mapActions, mapGetters } from "vuex";

export default {
  components: { DialogBase },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dataForm: {
        departmentName: "",
        departmentDescription: "",
      },
      customErrorMessages: {
        newNameKt: "",
      },
      showSaveChange: false,
      loadingButton: false,
      formRules: {
        departmentName: [
          {
            validator: this.changeDepartmentName,
            trigger: "change",
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters("departmentStore", ["departmentList"]),
  },
  methods: {
    ...mapActions("departmentStore", ["fetchDataDepartmentList"]),

    handleClose(done) {
      this.showSaveChange = false;
      this.customErrorMessages.newNameKt = "";
      this.$emit("dialog-close");
      this.$nextTick(() => {
        if (this.$refs.dataForm) {
          this.$refs.dataForm.resetFields();
        }
      });
      if (typeof done === "function") done();
    },

    changeDepartmentName(rule, value, callback) {
      if (this.departmentList.length !== 0) {
        for (let i = 0; i < this.departmentList.length; i++) {
          if (!value) {
            this.customErrorMessages.newNameKt =
              "Giá trị không được để trống!";
            this.showSaveChange = false;
            break;
          } else if (
            value.toLowerCase().replace(/\s/g, "") ===
            this.departmentList[i].departmentName
              .toLowerCase()
              .replace(/\s/g, "")
          ) {
            this.customErrorMessages.newNameKt =
              "Tên phòng ban: " +
              this.departmentList[i].departmentName +
              " đã tồn tại!";
            this.showSaveChange = false;
            break;
          } else {
            this.showSaveChange = true;
            this.customErrorMessages.newNameKt = "";
            callback();
          }
        }
      } else {
        this.showSaveChange = true;
        this.customErrorMessages.newNameKt = "";
        callback();
      }
    },

    handleSave() {
      this.$refs.dataForm.validate((valid) => {
        if (valid) {
          this.loadingButton = true;
          DepartmentDataService.create(this.dataForm)
            .then((resp) => {
              this.fetchDataDepartmentList();
              this.$message({
                message: resp.data.message,
                type: "success",
              });
              this.handleClose();
            })
            .catch((err) => {
              this.$message({
                message: err.response.data.message,
                type: "error",
              });
            })
            .finally(() => {
              this.loadingButton = false;
            });
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/style/sk-dialog";
</style>
